import AuthenticationWrapper from "./pages/AuthenticationWrapper";
import { Route, BrowserRouter, Routes } from "react-router-dom";
import Game from "./pages/Game";
import Coupon from "./pages/Coupon";
import "./index.css"
import RefreshToken from "./pages/RefreshToken";
import { MonitoringProvider } from "./utils/monitoring-context/MonitoringProvider";
import LmsRedirect from "./pages/LmsRedirect";
import AppRedirect from "./pages/AppRedirect";
import AppQrCode from "./pages/AppQrCode";
import {AuthenticationContextProvider} from "./auth/AuthenticationContextProvider";

const App = () => {
    return (
      <BrowserRouter>
          <AuthenticationContextProvider>
              <MonitoringProvider>
                  <Routes>
                      <Route element={<LmsRedirect/>} path="/lms-redirect"/>
                      <Route element={<Coupon/>} path="/coupon"/>
                      <Route element={<RefreshToken/>} path="/refresh-token"/>
                      <Route element={<AppRedirect/>} path="/get"/>
                      <Route element={<AppQrCode/>} path="/get-qr"/>
                      <Route element={
                          <AuthenticationWrapper>
                              <Game/>
                          </AuthenticationWrapper>
                      } path="*"/>
                  </Routes>
              </MonitoringProvider>
          </AuthenticationContextProvider>
      </BrowserRouter>
    )
}

export default App;